module.exports = __webpack_public_path__ + "static/whois-4cd1f5d6da2e3818f79eeb7adf0e2e3c.png";